if (!customElements.get('image-gallery-slider')) {
  class ImageGallerySlider extends HTMLElement {
    selectors = {
      swiper: '.swiper',
      scrollbar: '.swiper-scrollbar',
    };
    settings = {
      slidesPerView: 1.06,
      spaceBetween: 16,
      scrollbar: {
        el: this.selectors.scrollbar,
        draggable: true,
      },
      breakpoints: {
        600: {
          slidesPerView: 2.1,
        },
      },
    };
    slider = undefined;
    breakpoint = window.matchMedia('(max-width: 989px)');

    /**
     * Constructor.
     */
    constructor() {
      super();
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.init();

      this.breakpoint.addEventListener('change', (event) =>
        this.handleBreakpoint.bind(this),
      );
    }

    /**
     * Init.
     *
     * @returns {Void}
     */
    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      this.slider = new Swiper(swiper, this.settings);
    }

    /**
     * Destroy the slider.
     */
    destroy() {
      this.slider?.destroy();
    }

    /**
     * Handle breakpoint change.
     *
     * @param {MediaQueryListEvent} event
     */
    handleBreakpoint(event) {
      console.log('asdasda');
      console.log(event.matches);
      event.matches ? this.init() : this.destroy();
    }
  }
  customElements.define('image-gallery-slider', ImageGallerySlider);
}
